import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useStore } from '../../mobx-store';
import { observer } from 'mobx-react-lite';
import { CenteredLoading } from '../../components/CenteredLoading';
import { LandingPageBody } from './LandingPageBody';
import analytics from '../../services/analytics';
import { Box } from '@material-ui/core';
import { useQuery } from '../../hooks';

export default observer(function TalkingPointsLandingPage() {
    const { userId } = useParams();
    const { ShareablesStore } = useStore();
    const {
        loadedUser,
        loadingUser,
        user,
    } = ShareablesStore;

    const shareableSlug = useQuery()
        .get('slug');
    const shareableType = useQuery()
        .get('type');
    const landingPageType = useQuery()
        .get('landingPageType');
    const media = useQuery()
        .get('media') || 'screen';
    useEffect(()=> {
        if(!loadedUser) {
            ShareablesStore.getUser(userId);
        }
    }, [ShareablesStore, loadedUser, userId]);

    useEffect(()=> {
        if(loadedUser && media === 'screen') {
            analytics.eventTrack('shareable_consumer_page_viewed', {
                distinct_id: userId,
                'User Type': user.type === 'agent' ? 'Free' : 'Pro',
                'Type': landingPageType === 'normal'? 'normal' : 'premium',
                ...shareableSlug && { 'Shareable Slug': shareableSlug },
                ...shareableType && { 'Shareable Type': shareableType },
            });
        }
    }, [
        landingPageType,
        loadedUser,
        shareableSlug,
        shareableType,
        userId,
        user,
        media,
    ]);

    if(!loadedUser) {
        return <CenteredLoading height="100vh" />;
    }

    return (
        <Box height={{ md: media === 'print' ? 1 : '100vh' }} display="block">
            <Box
                display="flex"
                height="100%"
                width={1}
                mx="auto"
                flexDirection={{ xs: 'column', md: 'row' }}
                overflow={{ xs: 'auto', md: 'hidden' }}
            >
                <LandingPageBody user={user} loadedUser={loadedUser} loadingUser={loadingUser} media={media} />
            </Box>
        </Box>
    );
});
